import Temp from '@/courier/Temp'

export default class Teleport extends Temp {

    static CODE = 'TPSD';

    constructor() {
        super( Teleport.CODE ); 
    }

    getZone( item ){
        let type
        let cross_price = 0
        let remote_area = 0

        type = super.checkZone( item.toPostcode );
        
        return {
            rate_type : type ,
            rate_remote_area : remote_area ,
            cross_price : cross_price
        }
    }

    checkWeight( courierRates , item , validate ){
        item.index = courierRates.findIndex(rate => {
            return item.weight >= rate.min && item.weight <= rate.max
        })
        
        return super.checkRules( item , validate );
    }

    checkDimension( dimensionCourier , item , validate ){
        return super.checkCourierDimension( dimensionCourier , item , validate );
    }

}